import React, { useEffect, useState, useMemo } from 'react';
import { Link } from 'react-router-dom';
import DestaquesCards from '../Components/Destaques/destaquesCards';
import './index.css';

const TipoConteudoLabel = {
    1: 'Protocolos',
    2: 'Fluxogramas',
    3: 'Diretrizes',
    4: 'Documentos',
    5: 'Outros',
};

const ListaConteudo = ({ tipoConteudo, conteudos }) => {
    const [paginaAtual, setPaginaAtual] = useState(1);
    const itensPorPagina = 10;

    useEffect(() => {
        setPaginaAtual(1); // Reinicia ao mudar o tipo
    }, [tipoConteudo]);

    const conteudoList = useMemo(() => {
        if (!conteudos) return [];
        return [...conteudos].sort((a, b) => a.titulo.localeCompare(b.titulo, 'pt-BR', { sensitivity: 'base' }));
    }, [conteudos]);

    const totalPaginas = Math.ceil(conteudoList.length / itensPorPagina);
    const inicio = (paginaAtual - 1) * itensPorPagina;
    const conteudosPaginados = conteudoList.slice(inicio, inicio + itensPorPagina);

    return (
        <div>
            <div className="container py-5">
                <div className="section-title wow fadeInUp" data-wow-delay="0.1s">
                    <div className="sub-style">
                        <h4 className="sub-title px-3 mb-0">
                            {TipoConteudoLabel[tipoConteudo] ?? 'Treinamentos'}
                        </h4>
                    </div>
                </div>
            </div>

            {conteudosPaginados.length > 0 ? (
                <>
                    <ul className="lista-conteudos py-1">
                        {conteudosPaginados.map((conteudo) => (
                            <div key={conteudo.conteudoID}>
                                <Link to={`/conteudo/${conteudo.conteudoID}`} className="link-conteudo">
                                    <li className="item-conteudo">
                                        <div className="conteudo-linha">
                                            <div className="titulo-linha">
                                                <span className="titulo-conteudo">{conteudo.titulo}</span>
                                                <span className="data">
                                                    Atualizado em: {new Date(conteudo.updated).toLocaleDateString('pt-BR')}
                                                </span>
                                            </div>
                                            {conteudo.observacao && (
                                                <div className="observacao">
                                                    <i>- {conteudo.observacao}</i>
                                                </div>
                                            )}
                                        </div>
                                    </li>
                                </Link>
                            </div>
                        ))}
                    </ul>

                    {/* Paginação compacta */}
                    {totalPaginas > 1 && (
                        <div className="d-flex justify-content-center mt-3">
                            <nav>
                                <ul className="pagination pagination-sm">
                                    {[...Array(totalPaginas)].map((_, index) => {
                                        const page = index + 1;
                                        return (
                                            <li key={page} className={`page-item ${paginaAtual === page ? 'active' : ''}`}>
                                                <button className="page-link" onClick={() => setPaginaAtual(page)}>
                                                    {page}
                                                </button>
                                            </li>
                                        );
                                    })}
                                </ul>
                            </nav>
                        </div>
                    )}
                </>
            ) : (
                <div>
                    {tipoConteudo >= 1 && <p>Nenhum conteúdo disponível</p>}
                    <div className="container-fluid blog py-5">
                        <div className="container py-5">
                            <DestaquesCards />
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default ListaConteudo;
